import type { ContextKeyConfig, AgentToolDefinition } from '@multiplayer-app/ai-agent-react'

/**
 * Frontend context keys are UI-only config (independent of the server agents).
 * We use a server-valid key for chat routing, and list the client Office tool
 * names under it so they appear in the composer ToolShelf.
 */
export function buildContextKeys(
  contextKey: string,
  officeTools: AgentToolDefinition[]
): ContextKeyConfig[] {
  return [
    {
      key: contextKey,
      label: 'Office',
      description: 'Ramp AI with Office document tools',
      tools: officeTools.map((tool) => tool.name)
    }
  ]
}
